import { Button } from "@/shared/ui/button.tsx"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/ui/dialog.tsx"
import { format } from "date-fns"
import { CalendarIcon, SignpostBig } from "lucide-react"

import { cn } from "@/lib/utils"
import { Calendar } from "@/shared/ui/calendar.tsx"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/popover.tsx"
import { useEffect, useState } from "react"
import {  SocialPostType } from "./types"
import { useSchedulePost, useUpdatePostBody } from "./api/single-post-api"
import { useAtomValue } from "jotai"
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms"

type Props = {
  data: SocialPostType["content"][number],
  location: "scheduled" | "review" | "discarded",
  onSchedule: (id: number) => void
}

const DateCheckDialog = ({ data, location, onSchedule }: Props) => {

  const [date, setDate] = useState<Date>()

  const { updatePostBody, isSuccess, isPending } = useUpdatePostBody()

  const { schedulePost } = useSchedulePost(location, onSchedule)

  const saveInputAndScheduleHandler = () => {
    updatePostBody({
      post_date: format(date!, 'yyyy-MM-dd'),
      post_time: data.post_time,
      post_id: data.post_id,
      hashtags: data.tags,
      post_content: data.post_content
    })
  }

  useEffect(() => {

    if (isSuccess) {
      // call schedule api here
      schedulePost(data.post_id)
    }

  }, [isSuccess])

  const theme = useAtomValue(themeAtom)

  return (

    <Dialog>
      <DialogTrigger asChild>
            <Button type="button" style={{ backgroundColor: theme.primary }} className="max-sm:text-xs flex items-center gap-2">
          <SignpostBig /> Schedule Post
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Schedule Post</DialogTitle>
          <DialogDescription>
            There seems to be a date mismatch, change the date and proceed
          </DialogDescription>
        </DialogHeader>
        <Popover modal>
          <PopoverTrigger asChild>
            <Button
              variant={"outline"}
              className={cn(
                "w-full justify-start text-left font-normal",
                !date && "text-muted-foreground"
              )}
            >
              <CalendarIcon />
              {date ? format(date, "PPP") : <span>Pick a date</span>}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={date}
              onSelect={setDate}
              initialFocus
            />
          </PopoverContent>
        </Popover>
        <DialogFooter>
          <Button type="button" 
            disabled={date === undefined || isPending}
            onClick={saveInputAndScheduleHandler}
          >
            Save changes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DateCheckDialog;
